import { render, staticRenderFns } from "./QuickInfo.vue?vue&type=template&id=7d157ecf&scoped=true"
import script from "./QuickInfo.vue?vue&type=script&lang=ts"
export * from "./QuickInfo.vue?vue&type=script&lang=ts"
import style0 from "./QuickInfo.vue?vue&type=style&index=0&id=7d157ecf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d157ecf",
  null
  
)

export default component.exports